module.exports = __webpack_public_path__ + "static/img/clock.695dedd9.svg";